import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";

Vue.config.productionTip = false;

Amplify.configure(awsconfig);

new Vue({
  router,
  store,
  vuetify,
  Amplify,
  render: (h) => h(App),
}).$mount("#app");
